/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ClassificationItemKindEnum } from './classificationItemKindEnum';

/**
 * One taxonomy item of a classification: a skill (OVU) with its RVP area, a key competence or a literacy.
 */
export interface ClassificationItem { 
    uuid: string;
    kind: ClassificationItemKindEnum;
    title: string;
    /**
     * RVP area › subarea of a skill, category of a competence
     */
    group: string;
    /**
     * Official RVP wording of a competence (code: statement)
     */
    code: string;
}